<template>
  <v-container fluid class="add-template">
    <v-layout>
      <p>Hoe moet deze nieuwe <em>productgroep</em> heten?</p>
    </v-layout>
    <v-layout row style="flex-grow:0;">
      <v-flex xs12>
        <v-text-field
          name="input-1"
          label="Typ hier de naam van de productgroep"
          id="testing"
          v-model="categoryName"/>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import { EventBus } from '@/main'
  import { util } from '@/mixins'

  export default {
    name: 'add-category',
    data () {
      return {
        categoryName: ''
      }
    },
    methods: {
      addCategory () {
        // ADD VUELIDATE!!!
        if (this.categoryName.length === 0) return
        const category = {
          id: util.methods.generateID('category_'),
          name: this.categoryName,
          items: []
        }
        this.$store.commit('ADD_CATEGORY', category)
        this.categoryName = ''
        this.$store.commit('SET_CURRENT_CATEGORY', category.id)
        // this.$store.dispatch('toggleProductToList', category)
        this.$router.push({name: 'addProduct'})
        // this.$router.push({name: 'category', params: {id: category.id}})
        // this.$router.push({name: 'category', params: {id: this.$store.getters.getCurrentCategory}})
      }
    },
    mounted () {
      EventBus.$on('done-adding-category', () => {
        this.addCategory()
      })

      // console.log(genId.generateID())
      // genId.generateID()
    }
  }
</script>

<style lang="scss" scoped>
  p {
    font-size: 24px;
    text-align: center;
    em {
      font-weight: 600;
    }
  }

  .add-template {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding-bottom: 0;
  }
</style>



// WEBPACK FOOTER //
// AddCategory.vue?5dac3af2